<template>
  <div>
    <div
      class="card !border-none !p-1 m-0 !h-[calc(100vh-150px)] overflow-y-auto !bg-transparent"
      style="width: 100%"
      v-loading="loading"
      :element-loading-text="loadingText"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <h3 class="text-black-950 !font-normal text-sm 2xl:!text-base !m-0 !pb-4">App mode</h3>

      <el-form ref="form">
        <div class="!p-3 !border !border-page-border rounded-xl">
          <div class="">
            <span
              class="text-[13px] xl:text-sm 2xl:text-base text-black-950 !font-normal block !mb-2"
            >
              Developer mode
            </span>

            <el-switch
              style="display: block"
              v-model="appMode"
              active-color="var(--black-200)"
              inactive-color="var(--brand-500)"
              active-text="Off"
              inactive-text="On"
            ></el-switch>
            <el-link
              v-if="appMode && this.getAppMode"
              type="primary"
              class="mt-1"
              :underline="false"
              @click="fetchNewchanges"
            >
              Sync new changes
            </el-link>
            <el-alert
              class="!mt-4 !border-l-4 !border-brand-500 !bg-brand-100 rounded-[0_6px_6px_0] !text-black-950 text-xs xl:text-[13px] 2xl:Ltext-sm !p-3"
              :title="appMode ? note_on : note_off"
              :closable="false"
            ></el-alert>
          </div>
          <div v-if="!appMode && !this.getAppMode">
            <span
              class="text-[13px] xl:text-sm 2xl:text-base text-black-950 !font-normal !mb-1 block"
            >
              Troubleshoot
            </span>
            <el-alert
              class="!mt-2 !border-l-4 !border-brand-500 !bg-brand-100 rounded-[0_6px_6px_0] !text-black-950 text-xs xl:text-[13px] 2xl:Ltext-sm !p-3"
              title="Not seeing the latest information? Click 'Clear Cache' to reset and update your data for the latest updates!"
              type="info"
              show-icon
              :closable="false"
            ></el-alert>
            <el-link type="primary" class="mt-1" :underline="false" @click="clearCache">
              Clear Cache
            </el-link>
          </div>
        </div>

        <div class="card-footer !border-none !bg-transparent flex justify-start !mt-4 !pl-0">
          <el-form-item class="mb-0 !p-0">
            <el-button
              style="background: var(--brand-500) !important"
              class="!text-white !border-brand-500 !px-5 !py-2.5 !rounded-md text-xs 2xl:text-mds"
              type="button"
              @click="saveChanges"
            >
              Save
            </el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <el-dialog :visible.sync="centerDialogVisible" width="30%" center class="plain-header">
      <div class="icon-container">
        <img src="@/assets/img/SyncNewChanges.gif" />
        <p class="text-bold">{{ syncLoadingText }}</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { setApplicationSetup, clearDB } from '../../repo/appSettingRepo';
  export default {
    name: 'app-mode-configuration',
    data() {
      return {
        loadingText: 'Loading...',
        loading: false,
        appMode: false,
        centerDialogVisible: false,
        syncLoadingText: 'Please wait, we are setting things up for you...',
        loadingIntervalId: null,
        note_on:
          'All necessary data will be downloaded to ensure a seamless experience while using the application.',
        note_off:
          'Real-time data retrieval is essential during development to ensure the application always uses the most current information.',
      };
    },
    methods: {
      async clearCache() {
        this.loading = true;
        await clearDB();
        this.$notify.success({
          title: 'Success',
          message: 'Cleared data successfully',
        });
        this.loading = false;
      },
      getLoadingText() {
        const captions = [
          'Empower your team with low-code solutions.',
          'Build applications faster with low-code platforms.',
          'Low-code: The future of app development.',
          'Reduce development time with low-code.',
          'Transform your business processes with low-code tools.',
          'Accelerate digital transformation using low-code.',
          'Low-code: Simplifying complex workflows.',
          'Innovate quickly with low-code technology.',
        ];
        const randomIndex = Math.floor(Math.random() * captions.length);
        return captions[randomIndex];
      },
      generateRandomCaptions() {
        let that = this;
        this.loadingIntervalId = setInterval(function () {
          that.syncLoadingText = that.getLoadingText();
        }, 1500);
      },
      async fetchNewchanges() {
        this.centerDialogVisible = true;
        this.generateRandomCaptions();
        await setApplicationSetup();
        clearInterval(this.loadingIntervalId);
        this.loadingIntervalId = null;
        this.centerDialogVisible = false;
      },
      async saveChanges() {
        this.$store.commit('auth/setAppMode', this.appMode, {
          root: true,
        });
        this.$notify.success({
          title: 'Success',
          message: 'Settings saved successfully',
        });
        if (this.appMode) {
          this.fetchNewchanges();
        } else {
          clearDB();
        }
      },
    },
    computed: {
      ...mapGetters('auth', ['getAppMode']),
    },
    async mounted() {
      this.appMode = this.getAppMode;
    },
  };
</script>

<style scoped lang="scss">
  .card-body {
    padding: 25px;
  }
  .icon-container {
    text-align: center;
  }
</style>
